<template>
  <div class="flex items-center h-full">
    <feather-icon
      icon="EyeIcon"
      svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
      @click="onView" />
  </div>
</template>

<script>
export default {
  name: "CellRendererView",
  methods: {
    onView() {
      if (this.params.data && this.params.data.id != null && this.params.context && typeof this.params.context.openDetail === "function") {
        this.params.context.openDetail(this.params.data.id);
      }
    },
  },
};
</script>
